/* Copyright 2020 Avetti.com Corporation - All Rights Reserved

This source file is subject to the Avetti Commerce Front End License (ACFEL 1.20)
that is accessible at https://www.avetticommerce.com/license */ import React from "react";
import "./styles/CookieBtn.css";

function CookieBtn(props) {
  return (
    <button className="Button Success" onClick={props.click}>
      {props.children}
    </button>
  );
}

export default CookieBtn;
